import classNames from "classnames";

type TagProps = {
  children: string | JSX.Element | JSX.Element[];
  variants?: "default" | "outlined" | "danger" | "success";
};

const Tag = ({ children, variants = "default" }: TagProps) => {
  const classes = classNames(
    "inline-block px-2 py-[0.125rem] rounded tablet:text-base h-7 select-none !leading-[1.375rem]",
    {
      "bg-grey-lightest text-black": variants === "default",
      "bg-success-lightest text-success": variants === "success",
      "bg-error-lightest text-error": variants === "danger",
      "border text-grey-dark !bg-none": variants === "outlined",
    },
  );

  return <div className={classes}>{children}</div>;
};

export default Tag;
